/**
 * @generated SignedSource<<fdd3cdb65a16f239687ed431e7495708>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_TranscriptSegment_note$data = {
  readonly id: string;
  readonly " $fragmentType": "TranscriptPanel_TranscriptSegment_note";
};
export type TranscriptPanel_TranscriptSegment_note$key = {
  readonly " $data"?: TranscriptPanel_TranscriptSegment_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_TranscriptSegment_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_TranscriptSegment_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "995b42cb0ea3616b5ef28aa81630437f";

export default node;
